import CrudCustom from '../../../libs/custom/CrudCustom';

let JenisUsahaService = new CrudCustom('/tipe-bisnis-asets');
export default JenisUsahaService;
